module.exports = __webpack_public_path__ + "img/roundup_orange.dda0cb3b.svg";